@if (
  {
    row: columnData | async,
    aData: additionData | async,
  };
  as $
) {
  @if ($.row && $.aData && !isEmptyAndNull($.row[$.aData.primary])) {
    <span [ngClass]="$.aData.color ? getColor($.row[$.aData.color]) : ''">
      {{ $.row[$.aData.primary] }}</span
    >
  } @else {
    @if (!isEmptyAndNull($.row[$.aData.secondary])) {
      <span [ngClass]="$.aData.color ? getColor($.row[$.aData.color]) : ''">{{
        $.row[$.aData.secondary]
      }}</span>
    } @else {
      -
    }
  }
}
